/***
 * @file: ç¡®è®¤æå¡
 * @author: linkun.he
 * @Date: 2020-06-18 10:18:08
 */
import { Injectable } from '@angular/core';
import { I18NService } from '@ithinkdt/shared/i18n';
import { NzModalService } from 'ng-zorro-antd/modal';
import { Subject } from 'rxjs';

import { DtConfirmModule } from './confirm.module';

@Injectable({
  providedIn: DtConfirmModule,
})
export class ConfirmService {
  /**
   * ç¡®è®¤äºä»¶çå¬
   */

  confirm$ = new Subject();

  constructor(private modalService: NzModalService, private i18n: I18NService) {}

  /**
   * ç¡®è®¤å¯¹è¯æ¡
   * @param title å¯¹è¯æ¡æ é¢
   * @desc è¥ä¼ å¥ä¸ä¸ªæ¹æ³ï¼é»è®¤æ¯ç¡®å®çåè°æ¹æ³ï¼ä¼ çç¬¬äºä¸ªæ¹æ³ææ¯åæ¶çåè°æ¹æ³
   */
  confirm(title: string, ok?, cancel?) {
    // if(ok && !cancel){
    //   console.warn("è¥ä¼ å¥çæ¯åæ¶çåè°æ¹æ³ï¼è¯·åä¼ å¥ç¡®è®¤çåè°æ¹æ³ï¼")
    // }
    this.modalService.confirm({
      nzTitle: this.i18n.interpret(title),
      nzOkText: this.i18n.interpret('operations.ok'),
      nzOkType: 'warning',
      nzOnOk: () => {
        this.emitComfirm(true);
        if (ok) {
          ok();
        }
      },
      nzCancelText: this.i18n.interpret('operations.cancel.cancel'),
      nzOnCancel: () => {
        if (cancel) {
          cancel();
        }
        this.emitComfirm(false);
      },
    });
  }

  /**
   * ç¡®è®¤äºä»¶æ¨é
   * @param bool å¸å°å¼ï¼ trueä»£è¡¨ç¡®å®ï¼ falseä»£è¡¨åæ¶
   */

  emitComfirm(bool: boolean) {
    this.confirm$.next(bool);
  }

  get tt() {
    return '1243';
  }
}
